import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { GetHierarchiesRequest, GetHierarchiesResponse, HierarchyItem } from './dto';
import { HierarchiesAPIRoutes } from './route';

const mapResponse = (response: GetHierarchiesResponse): HierarchyItem[] => {
  return (response.items || []).map((item) => ({
    taxonomy_id: item.taxonomy_id,
    parent: item.parent_taxonomy_id,
    descriptor: item.descriptor,
    alias: item.taxonomy_alias,
    row_key: item.taxonomy_id,
    has_children: item.has_children,
  }));
};

export const fetchGetHierarchies = async (
  body: Omit<GetHierarchiesRequest, 'columnNames'>,
): Promise<HierarchyItem[]> => {
  const payload = {
    ...body,
    columns: ['parent_taxonomy_id', 'taxonomy_alias', 'has_children'],
  };
  const result = await makeRequest<GetHierarchiesResponse>(api.post(HierarchiesAPIRoutes.getHierarchies(), payload));

  return mapResponse(result);
};
